import React from 'react'
import Navigation from './Navigation'
import Drawer from 'material-ui/Drawer'
import Header from './Header'
import classNames from 'classnames'
import { withStyles } from 'material-ui/styles'
import * as configActions from 'actions/config'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import Dialog from 'components/Dialog'
import MainCurrencySelector from 'components/MainCurrencySelector'
import { CircularProgress } from 'material-ui/Progress'

const drawerWidth = 240
const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '100%',
    backgroundColor: theme.palette.background.default,
    // overflowX: 'hidden',
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: '100%',
  },
  drawerPaper: {
    position: 'fixed',
    height: '100%',
    width: drawerWidth,
  },
  content: {
    marginLeft: 0,
    flexGrow: 1,
    minHeight: '100%',
    marginTop: 74,
    [theme.breakpoints.up('sm')]: {
      content: {
        height: 'calc(100% - 74px)',
      },
    },
  },
  loader: {
    marginTop: 74 + 200,
    flexGrow: 1,
    justifyContent: 'center',
    display: 'flex',
  },
  main: {
    color: theme.palette.text.primary,
  },
})

const Layout = ({
  classes,
  children,
  isSidebarOpen,
  toggleSidebar,
  isLoading,
}) => (
  <div className={classes.root}>
    <Dialog />
    <div className={classes.appFrame}>
      <Header
        onToggleMenu={toggleSidebar}
        className={classNames(classes.appBar)}
      />
      <Drawer
        anchor="left"
        onRequestClose={toggleSidebar}
        classes={{
          paper: classes.drawerPaper,
        }}
        open={isSidebarOpen}
      >
        <div>
          <Navigation />
        </div>
      </Drawer>
      {isLoading && (
        <div className={classNames(classes.loader)}>
          <CircularProgress size={100} />
        </div>
      )}
      {!isLoading && (
        <main className={classNames(classes.content, classes.main)}>
          {children}
        </main>
      )}
    </div>
    <MainCurrencySelector />
  </div>
)

const mapStateToProps = state => ({
  isSidebarOpen: state.config.isSidebarOpen,
  isLoading: selectors.checkAuth(state),
})

const mapDispatchToProps = dispatch => ({
  toggleSidebar: () => dispatch(configActions.toggleSidebar()),
})

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Layout)
)



// WEBPACK FOOTER //
// ./src/components/Layout.js